import { gameActor } from "services";
import { UserState } from "actors/user.actor";
import { GameState } from "actors/game.actor";
import { DigimonState } from "actors/digimon.actor";

import { setGui } from "components/app";
import { GuiState } from "states/gui.state";
import ActionButton from "components/widgets/action-button";

export default function FoodButton(props: {
    gui: GuiState,
    game: GameState,
    user?: UserState,
    digimon?: DigimonState,
    active: boolean,
})
{
    // Actions:
    const food = () => {
        const action: string = props.user?.action === "food" ? "" : "food";
        gameActor.userActor?.setAction(action);
        setGui({
            submenu: props.gui.submenu === "food" ? "" : "food",
        });
    }

    // Component:
    return props.digimon && props.digimon.dto.level > 0 ? (
        <ActionButton
            icon="food"
            name="Food"
            description="Feed your Digimon from a selection of food items. (You can place up to 3 food items at once)."
            active={props.active}
            onClick={() => food()}
            disabled={props.game.ownedItemTypeCounts["food"] >= 3}
        />
    ) : (<></>);
}